export default __webpack_public_path__ + "images/multilang-offer-step-1.d1521fba577c7a6128b91818bb562937.png";